// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"58d925cf","313":"df91eca8","327":"df91eca8","353":"2b0692f3","438":"df91eca8","629":"df91eca8","874":"0882ad9d","924":"df91eca8"}[chunkId] + ".chunk.css";
};